<template>
  <div id="change-order-progress">
    <ul>
      <li :class="progressClass(1)">
        {{ i18n.t('/ChangeOrderActions/ProgressBar/Concept') }}
      </li>
      <li :class="progressClass(2)">
        {{ i18n.t('/ChangeOrderActions/ProgressBar/SignPending') }}
      </li>
      <li :class="progressClass(3)">
        {{ i18n.t('/ChangeOrderActions/ProgressBar/SignCompleted') }}
      </li>
      <li :class="progressClass(4)">
        {{ i18n.t('/ChangeOrderActions/ProgressBar/Submitted') }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapState('changeOrder', ['changeOrder']),
    ...mapGetters('changeOrder', {
      isStatusConcept: 'changeOrderStatusIsConcept',
      isSigningStatusEmpty: 'changeOrderSigningStatusIsEmpty',
      isSigningStatusPending: 'changeOrderSigningStatusIsPending',
      isSigningStatusCompleted: 'changeOrderSigningStatusIsCompleted',
      isChangeOrderStatusSubmitted: 'changeOrderStatusIsSubmitted',
    }),
    currentStatusProgress() {
      // Step 1: Concept
      if (this.isStatusConcept && this.isSigningStatusEmpty) {
        return 1
      }

      // Step 2: Order unsigned (PDF sent, waiting for signature)
      if (this.isStatusConcept && this.isSigningStatusPending) {
        return 2
      }

      // Step 3: Order signed (signature completed)
      if (this.isStatusConcept && this.isSigningStatusCompleted) {
        return 3
      }

      // Step 4: Submitted (order is no longer in concept)
      if (this.isChangeOrderStatusSubmitted || !this.isStatusConcept) {
        return 4
      }

      return 1
    },
  },
  methods: {
    progressClass(stepNumber) {
      let currentProgress = this.currentStatusProgress
      let progressClass = ''

      if (stepNumber < currentProgress) progressClass = 'done'
      else if (stepNumber === currentProgress) progressClass = 'current'

      return progressClass
    },
  },
}
</script>

<style lang="scss" scoped>
#change-order-progress {
  max-width: 1250px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0.5em;
  padding: 0;
  list-style-type: none;
  clear: both;
  line-height: 1em;
  text-align: center;
  display: flex;
}

#change-order-progress ul {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style-type: none;
}

#change-order-progress li {
  flex: 1;
  float: left;
  padding: 10px 30px 10px 40px;
  background: #666;
  color: #fff;
  position: relative;
  border-top: 1px solid #666;
  border-bottom: 1px solid #666;
  margin: 0 1px;
}

#change-order-progress li:before {
  content: '';
  border-left: 16px solid #fff;
  border-top: 16px solid transparent;
  border-bottom: 16px solid transparent;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}
#change-order-progress li:after {
  content: '';
  border-left: 16px solid #666;
  border-top: 16px solid transparent;
  border-bottom: 16px solid transparent;
  position: absolute;
  top: 0;
  left: 100%;
  height: 100%;
  z-index: 20;
}

#change-order-progress li.done {
  background: var(--color-primary-dark);
}

#change-order-progress li.done:after {
  border-left-color: var(--color-primary-dark);
}

#change-order-progress li.current {
  background: var(--color-primary);
}

#change-order-progress li.current:after {
  border-left-color: var(--color-primary);
}
</style>
